import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { getAttachmentLink } from 'utils/attachmentOperations'

import styles from './styles'

function AttachmentsList(props) {
  const { attachments, title = 'Anexos', expanded = false } = props

  const classes = styles()

  const [attachmentsList, setAttachmentsList] = useState([])
  const token = useSelector((state) => state.auth.access_token)

  const generateAttachmentsWithLinks = async () => {
    const promises = attachments.map((attachment) => {
      return getAttachmentLink(attachment.uuid, token)
    })
    Promise.all(promises).then((values) => {
      const withLinks = values.map((value, index) => {
        return {
          document_url: value,
          uuid: attachments[index].uuid,
          file_name: attachments[index].file_name,
        }
      })
      setAttachmentsList(withLinks)
    })
  }

  useEffect(() => {
    generateAttachmentsWithLinks()
  }, [attachments])

  return (
    <div className={expanded ? classes.root : ''}>
      <h4>{title}</h4>
      <ul className={classes.attachmentList}>
        {attachmentsList.map((attachment) => (
          <li className={classes.listItem} key={attachment.uuid}>
            <a href={attachment.document_url}>{attachment.file_name}</a>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default AttachmentsList
